import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import { DashboardFilters, ReadsDto } from 'src/types/dashboard';
import { TransactionSummary } from 'src/types/station';
export const dashboardAPI = createApi({
  reducerPath: 'dashboardAPI',
  baseQuery: axiosBaseQueryWithReauth({
    baseUrl: process.env.REACT_APP_API_URL
  }),
  endpoints: (builder) => ({
    getStationReads: builder.query<ReadsDto, DashboardFilters>({
      query: ({ storeId, timeDuration, graphType, clientId }) => ({
        url: 'Stations/reads',
        method: 'GET',
        params: {
          clientId,
          filters: JSON.stringify({
            StoreId: storeId,
            TimeDuration: timeDuration,
            GraphType: graphType
          })
        }
      }),
    }),
    getTransactionSummary: builder.query<TransactionSummary, DashboardFilters>({
      query: ({storeId, startDate, endDate, timeDuration,clientId }) => ({
        url: 'Transactions/summary',
        method: 'GET',
        params: {
          clientId,
          filters: JSON.stringify({
            StoreId: storeId,
            startDate,
            endDate,
            TimeDuration: timeDuration
          })
        }
      }),
    })
  })
});

export const {
  useGetStationReadsQuery,
  useGetTransactionSummaryQuery
} = dashboardAPI;
